const stepTypes = {
	BASICINFO: 'BASICINFO',
	YOURFIT: 'YOURFIT',
	YOURKIT: 'YOURKIT',
	VERIFICATIONS: 'VERIFICATIONS'
}

export default stepTypes



// WEBPACK FOOTER //
// ./src/enums/stepTypes.js